module.exports = __webpack_public_path__ + "static/media/logo_shng.d612858f.svg";